// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import styles from './styles.css.js';
export var AdditionalInfo = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles['additional-info'] }, children));
};
//# sourceMappingURL=additional-info.js.map